



















import { Component, Prop, Vue } from 'vue-property-decorator'
import PageHeader from '@/admin/components/PageHeader.vue'
import __ from '@/shared/helpers/__'
import Form from '@/shared/components/form/Form.vue'
import { GlobalActions } from '@/shared/store/global/global.actions'
import FormBase from '@/shared/classes/form/form-base'
import Violation from '@/shared/modules/violation/violation.model'
import { FieldTypes } from '@/shared/components/form/field-types'
import Field, { FieldSizes } from '@/shared/classes/form/field'
import SelectField from '@/shared/classes/form/fields/Select/select-field'
import SearchableField from '@/shared/classes/form/fields/Select/searchable-field'
import Company from '@/shared/modules/company/company.model'
import { CompanyGetters } from '@/shared/store/company/company.getters'
import IViolationResponse from '@/shared/modules/violation/violation-response.interface'
import ViolationService from '@/shared/modules/violation/violation.service'
import FormGroup from '@/shared/classes/form/group'
import _ from 'lodash'
import { RoleLevel } from '@/shared/modules/role/role.model'
import User from '@/shared/modules/user/user.model'
import { AuthGetters } from '@/shared/store/auth/auth.getters'
import { validateFields } from "@/shared/helpers/validate";
import { SnackBarTypes } from "@/shared/helpers/snack-bar.helper";

@Component({
  components: { Form, PageHeader },
  methods: { __ }
})
export default class AddViolationDialog extends Vue {
  @Prop() meta!: any

  static GROUP_DETAILS = 'details'
  static GROUP_ATTACHMENTS = 'attachments'

  attachmentsData: any = {}
  form: FormBase = new FormBase()
    .setEndpoint(`company/${ this.company.slug }/violations`)
    .setModel(Violation)
    .setTranslatable(true)
    .setGroups([
      new FormGroup()
        .setKey(AddViolationDialog.GROUP_DETAILS),
      new FormGroup()
        .setKey(AddViolationDialog.GROUP_ATTACHMENTS)
        .setTitle(__('company.components.violations.add-violation-dialog.form.groups.attachments')),
    ])
    .setFields([
      new SearchableField()
        .setKey('project_uuid')
        .setEntryKey('projectUuid')
        .setTitle(__('company.components.tasks.add-task-dialog.form.project'))
        .setDisabled(!! this.meta.project)
        .setGroup(AddViolationDialog.GROUP_DETAILS)
        .loadItems({ endpoint: `company/${ this.company.slug }/projects`, value: 'uuid', title: 'name', perPage: 20 })
        .setRequired(!this.meta.isFromHSE),
      new Field()
        .setKey('name')
        .setTranslatable(true)
        .setTitle(__('company.components.violations.add-violation-dialog.form.name'))
        .setGroup(AddViolationDialog.GROUP_DETAILS)
        .isRequired(),
      new Field()
        .setType(FieldTypes.textArea)
        .setKey('description')
        .setTranslatable(true)
        .setTitle(__('company.components.violations.add-violation-dialog.form.description'))
        .setGroup(AddViolationDialog.GROUP_DETAILS),
      new Field()
        .setType(FieldTypes.datePicker)
        .setKey('seen_at')
        .setEntryKey('seenAt')
        .setTitle(__('company.components.violations.add-violation-dialog.form.seen-at'))
        .setSize(FieldSizes.half)
        .setGroup(AddViolationDialog.GROUP_DETAILS),
      new Field()
        .setType(FieldTypes.datePicker)
        .setKey('deadline')
        .setTitle(__('company.components.violations.add-violation-dialog.form.deadline'))
        .setSize(FieldSizes.half)
        .setGroup(AddViolationDialog.GROUP_DETAILS),
      new SelectField()
        .setKey('type_uuid')
        .setEntryKey('typeUuid')
        .setTitle(__('company.components.violations.add-violation-dialog.form.type'))
        .loadItems({ endpoint: 'violation-types', value: 'uuid', title: 'name' })
        .setDisabled(!!this.meta.isFromHSE)
        .setSize(FieldSizes.half)
        .setGroup(AddViolationDialog.GROUP_DETAILS)
        .isRequired()
        .setOnChange((value: string) => {
          const projectField = this.form.fields.find(field => field.key === 'project_uuid');
          // Project is not required if 'Health, safety & environment' is selected
          if (value === 'ds') projectField?.setRequired(false);
          else projectField?.setRequired(true);
        }),
      new SelectField()
        .setKey('status_uuid')
        .setEntryKey('statusUuid')
        .setTitle(__('company.components.violations.add-violation-dialog.form.status'))
        .loadItems({ endpoint: `statuses/model/${ Violation.ALIAS }`, value: 'uuid', title: 'name', perPage: 20 })
        .setSize(FieldSizes.half)
        .setGroup(AddViolationDialog.GROUP_DETAILS)
        .isRequired(),
      new SearchableField()
        .setKey('responsible_uuid')
        .setEntryKey('responsibleUuid')
        .setTitle(__('company.components.violations.add-violation-dialog.form.responsible'))
        .setDisabled(this.user.role.level === RoleLevel.employee)
        .loadItems({ endpoint: `company/${ this.company.slug }/employees`, value: 'uuid', title: 'full_name', perPage: 20 })
        .setSize(FieldSizes.half)
        .setGroup(AddViolationDialog.GROUP_DETAILS),
      new SearchableField()
        .setKey('responsible_employee_uuid')
        .setEntryKey('responsibleEmployeeUuid')
        .setTitle(__('company.components.violations.add-violation-dialog.form.responsible-employee'))
        .setDisabled(this.user.role.level === RoleLevel.employee)
        .loadItems({ endpoint: `company/${ this.company.slug }/employees`, value: 'uuid', title: 'full_name', perPage: 20 })
        .setSize(FieldSizes.half)
        .setGroup(AddViolationDialog.GROUP_DETAILS),
      new Field()
        .setKey('location')
        .setTitle(__('company.components.violations.add-violation-dialog.form.location'))
        .setTranslatable(true)
        .setSize(FieldSizes.half)
        .setGroup(AddViolationDialog.GROUP_DETAILS),
      new Field()
        .setKey('solution')
        .setSize(FieldSizes.half)
        .setTitle(__('company.components.violations.add-violation-dialog.form.solution'))
        .setTranslatable(true)
        .setGroup(AddViolationDialog.GROUP_DETAILS),
      new Field()
        .setType(FieldTypes.dropzone)
        .setKey('attachments')
        .setTitle(__('company.components.violations.add-violation-dialog.form.attachments.upload'))
        .setGroup(AddViolationDialog.GROUP_ATTACHMENTS),
      new Field()
        .setKey('attachments_comment')
        .setTitle(__('company.components.violations.add-violation-dialog.form.attachments.comment'))
        .setGroup(AddViolationDialog.GROUP_ATTACHMENTS),
    ])
    .setInitialValues({
      projectUuid: _.get(this.meta, 'project.uuid', null),
      typeUuid: this.meta.isFromHSE ? 'ds' : null,
    })
    .setSubmit({
      text: __('company.components.violations.add-violation-dialog.form.submit'),
    })
    .setChangeDataBeforeSubmit((data: any) => {
      const { attachments, attachments_comment } = data
      this.attachmentsData = {
        attachments,
        attachments_comment,
      }
      delete data.attachments
      delete data.attachments_comment

      return data
    })
    .setValidate((data) => {
      const errors = validateFields(data, this.form?.fields, { onError: this.onError, onlyRegionLangRequired: true });
      if (errors) {
        this.form?.setErrors(errors);
        return false;
      }

      return true;
    })
    .setOnSuccess(async (response: IViolationResponse, violation: Violation) => {
      if (this.attachmentsData.attachments.length !== 0) {
        let data = new FormData()
        data.set('description', this.attachmentsData.attachments_comment)
        this.attachmentsData.attachments.forEach((attachment: File, index: number) => {
          data.set(`attachment_${ index }`, attachment)
        })

        await ViolationService.uploadAttachments(this.company, violation.uuid, data)
      }

      await this.$store.dispatch(GlobalActions.showSnackBar, {
        type: 'success',
        message: __('company.components.violations.add-violation-dialog.form.on-success'),
      })

      await this.closeDialog()
      this.meta.onSuccess && this.meta.onSuccess()
    })

  onError() {
    this.$store.dispatch(GlobalActions.showSnackBar, {
      type: SnackBarTypes.error,
      message: __("validation.fill-all-field"),
    });
  }

  async closeDialog() {
    await this.$store.dispatch(GlobalActions.closeDialog)
  }

  get company(): Company {
    return this.$store.getters[CompanyGetters.getCompany]
  }

  get user(): User {
    return this.$store.getters[AuthGetters.getUser]
  }
}
